"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RULE_DICTIONARY = void 0;
const ExactValueRule = require("./ExactValueRule");
const MaxLengthRule = require("./MaxLengthRule");
const RequiredRule = require("./RequiredRule");
const ValidUrlPathRule = require("./ValidUrlPathRule");
const ValidUrlRule = require("./ValidUrlRule");
const LengthRule = require("./LengthRule");
const CompositeRule_1 = require("./CompositeRule");
exports.RULE_DICTIONARY = {
    [CompositeRule_1.CompositeRule.NAME]: (config) => new CompositeRule_1.CompositeRule(config),
    [ExactValueRule.NAME]: ExactValueRule.rule,
    [MaxLengthRule.NAME]: MaxLengthRule.rule,
    [RequiredRule.NAME]: RequiredRule.rule,
    [ValidUrlPathRule.NAME]: ValidUrlPathRule.rule,
    [ValidUrlRule.NAME]: ValidUrlRule.rule,
    [LengthRule.NAME]: LengthRule.rule,
};
//# sourceMappingURL=index.js.map